/* YOSHAM mobile menu drill-down (snippets/yosham-mega-drawer.liquid) */
(function () {
  function reset(root) {
    root.classList.remove('is-sub');
    root.querySelectorAll('[data-yo-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () {
      if (!root.classList.contains('is-sub')) root.querySelectorAll('.yo-drill__sub').forEach(function (s) { s.hidden = true; });
    }, 320);
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-yo-open]');
    if (open) {
      var root = open.closest('[data-yo-drill]');
      var id = open.getAttribute('aria-controls');
      root.querySelectorAll('.yo-drill__sub').forEach(function (s) { s.hidden = s.id !== id; });
      open.setAttribute('aria-expanded', 'true');
      root.classList.add('is-sub');
      var drawer = root.closest('.drawer');
      if (drawer) drawer.scrollTop = 0;
      var back = document.getElementById(id).querySelector('[data-yo-back]');
      if (back) back.focus({ preventScroll: true });
      return;
    }
    var back = e.target.closest('[data-yo-back]');
    if (back) {
      var r = back.closest('[data-yo-drill]');
      var opener = r.querySelector('[aria-controls="' + back.closest('.yo-drill__sub').id + '"]');
      reset(r);
      if (opener) opener.focus({ preventScroll: true });
      return;
    }
    if (e.target.closest('.js-drawer-close')) {
      document.querySelectorAll('[data-yo-drill].is-sub').forEach(reset);
    }
  });
})();
